'use strict';

angular.module('admin.template', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.templates', {
        url: 'templates',
        model: 'Template',
        viewOptions: 'templateViewOptions',
        title: 'Template',
        modelNameField: 'title',
        edit: {
            templateUrl: 'admin/template/template.edit.html',
            controller: 'EditCtrl',
            defaults: {
                display_order: 1,
            }
        },
    });
})

.factory('templateViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    listView
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        queryDefaults: {
            sort: [
                ['id', 'DESC'],
            ],
        },
        list: {
            columns: [
                {
                    label: 'Title',
                    name: 'title',
                   // template: listNameTemplate('title', 'asset.links.thumb'),
                    sortable: true,
                },
                {
                    label: 'Edit',
                    name: 'edit',
                    template: '<a target="_blank" ui-sref="templateEdit({id: model.id})">Edit</a>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        views: [listView],
    });
});
